// Path: src/components/aols/aeo/OLSupdates/OLS2900/OLSLM2924.tsx
// Created new page for OLSLM Update 2924 based on OLSLM2923
// Features new meditation sessions and Odysee links
// 06/03/25 06:36 PM +07
import React, { useEffect } from "react";
import { Layout, Typography, Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import styled from "styled-components";
import { HomeOutlined } from "@ant-design/icons";
import { InlineShareButtons } from "sharethis-reactjs";
import Footer from "../../../../dev/utils/Footer/Footer";
import { updates2900 } from "./OLS2900";
import { useFirebase } from "../../../../dev/Firebase/Firebase";

const { Title, Paragraph } = Typography;

const UpdateContainer = styled.div`
  background: #000000;
  min-height: 100vh;
  padding: 40px 20px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const UpdateContent = styled.div`
  max-width: 800px;
  width: 100%;
  background: #1a1a1a;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
  text-align: center;
`;

const UpdateTitle = styled(Title)`
  && {
    color: #ffcc00 !important;
    margin-bottom: 20px;
  }
`;

const UpdateParagraph = styled(Paragraph)`
  && {
    color: #fff !important;
    font-size: 16px;
    line-height: 1.8;
    margin-bottom: 24px;
  }
`;

const UpdateLink = styled.a`
  color: #ffaa00 !important;
  text-decoration: none;
  font-size: 16px;
  transition: color 0.3s ease;

  &:hover {
    color: #ffcc00 !important;
    text-decoration: underline;
  }

  &:focus {
    outline: 2px solid #40c4ff;
    outline-offset: 2px;
  }
`;

const HighlightedText = styled.span`
  font-size: 48px;
  color: #ffcc00;
`;

const UpdateImage = styled.img`
  max-width: 100%;
  border-radius: 8px;
  margin: 20px 0;
`;

const BreadcrumbWrapper = styled.div`
  position: absolute;
  top: 10px;
  left: 20px;
  z-index: 1001;

  .ant-breadcrumb a {
    color: #ffcc00;
    transition: color 0.3s ease;
  }

  .ant-breadcrumb a:hover {
    color: #ffaa00;
  }

  @media (max-width: 768px) {
    left: 10px;
    top: 5px;
    .ant-breadcrumb {
      font-size: 12px;
    }
  }
`;

const ShareThisWrapper = styled.div`
  margin-top: 20px;
  padding: 10px;
  background: #1a1a1a;
  border-radius: 8px;
  display: flex;
  justify-content: center;

  .st-btn {
    border: 1px solid #ffcc00 !important;
    border-radius: 4px !important;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }

    &:focus {
      outline: 2px solid #40c4ff;
      outline-offset: 2px;
    }
  }

  .st-total {
    color: #fff !important;
    font-size: 16px;
  }
`;

const OLSLM2924: React.FC = () => {
  console.log("OLSLM2924 component rendering - updates2900:", updates2900);
  const update = updates2900.find((u) => u.id === "2924.olslm");
  const { logEvent } = useFirebase();

  useEffect(() => {
    logEvent("page_view", { page_path: "/olsupdates/ols2900/2924.olslm" });
    logEvent("post_viewed", { post_id: "2924.olslm", post_title: "OLSLM: 2924.126.3413" });
  }, [logEvent]);

  if (!update) {
    console.log("Update 2924.olslm not found in updates2900");
    return null;
  }

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: "OLSLM: 2924.126.3413 - onelightsystem OLS",
    description:
      "Explore the latest OLSLM update for onelightsystem OLS, featuring enhanced Sun Light Meditation sessions and resources for our radiant community.",
    url: "https://www.olsme.com/olsupdates/ols2900/2924.olslm",
    datePublished: "2025-06-03",
    author: {
      "@type": "Organization",
      name: "onelightsystem OLS",
      url: "https://www.olsme.com",
    },
    publisher: {
      "@type": "Organization",
      name: "onelightsystem OLS",
      url: "https://www.olsme.com",
      logo: "https://www.olsme.com/logo.jpg",
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://www.olsme.com/olsupdates/ols2900/2924.olslm",
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.olsme.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "OLS Updates",
          item: "https://www.olsme.com/olsupdates",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "OLS2900",
          item: "https://www.olsme.com/olsupdates/ols2900",
        },
        {
          "@type": "ListItem",
          position: 4,
          name: "OLSLM: 2924.126.3413",
          item: "https://www.olsme.com/olsupdates/ols2900/2924.olslm",
        },
      ],
    },
  };

  return (
    <Layout>
      <Helmet>
        <title>OLSLM: 2924.126.3413 - onelightsystem OLS</title>
        <meta
          name="description"
          content="Explore the latest OLSLM update for onelightsystem OLS, featuring enhanced Sun Light Meditation sessions and resources for our radiant community."
        />
        <meta
          name="keywords"
          content="OLSLM update, onelightsystem OLS, Sun Light Meditation, OLS updates, Light Civilization, meditation education, Firebase Analytics"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="onelightsystem OLS" />
        <link
          rel="canonical"
          href="https://www.olsme.com/olsupdates/ols2900/2924.olslm"
        />
        <meta
          property="og:title"
          content="OLSLM: 2924.126.3413 - onelightsystem OLS"
        />
        <meta
          property="og:description"
          content="Explore the latest OLSLM update for onelightsystem OLS, featuring enhanced Sun Light Meditation sessions and resources for our radiant community."
        />
        <meta
          property="og:url"
          content="https://www.olsme.com/olsupdates/ols2900/2924.olslm"
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:image"
          content="https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F732.3.126.png?alt=media&token=7c4a09b7-4781-4211-8484-c623b614ba66"
        />
        <meta
          property="og:image:alt"
          content="OLSLM Update 2924.126.3413 - Sun Light Meditation"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="onelightsystem OLS" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@onelightsystem" />
        <meta
          name="twitter:title"
          content="OLSLM: 2924.126.3413 - onelightsystem OLS"
        />
        <meta
          name="twitter:description"
          content="Explore the latest OLSLM update for onelightsystem OLS, featuring enhanced Sun Light Meditation sessions and resources for our radiant community."
        />
        <meta
          name="twitter:image"
          content="https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F732.3.126.png?alt=media&token=7c4a09b7-4781-4211-8484-c623b614ba66"
        />
        <meta
          name="twitter:image:alt"
          content="OLSLM Update 2924.126.3413 - Sun Light Meditation"
        />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <BreadcrumbWrapper>
        <Breadcrumb
          items={[
            {
              title: (
                <Link to="/">
                  <HomeOutlined /> Home
                </Link>
              ),
            },
            {
              title: <Link to="/olsupdates">OLS Updates</Link>,
            },
            {
              title: <Link to="/olsupdates/ols2900">OLS2900</Link>,
            },
            {
              title: "OLSLM: 2924.126.3413",
            },
          ]}
        />
      </BreadcrumbWrapper>

      <UpdateContainer>
        <UpdateContent>
          <UpdateTitle level={1}>OLSLM: 2924.126.3413</UpdateTitle>
          <UpdateParagraph>
            [ 732.3.126.3399, 732.12.126.3399, 1463.1.126.3401, 1828.1.126.3402, 2193.1.126.3402 (OLS student) ]
          </UpdateParagraph>
          <UpdateParagraph>
            Welcome to OLSLM Update 2924, a radiant step forward in our Sun Light Meditation journey! This update introduces enhanced meditation sessions, empowering our global community with deeper transformative practices.
          </UpdateParagraph>
          <UpdateParagraph>
            <UpdateLink
              href="https://odysee.com/@onelightsystemOLS:f/732.-olsm___3lh-126-2-40:e?r=7Lzv2RSF7jJWdCHdCm1Tnckp8TYcaK6o"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Watch 732.3.126.3399 video on Odysee"
            >
              <HighlightedText>732.3.126.3399</HighlightedText>
            </UpdateLink>
          </UpdateParagraph>
          <UpdateImage
            src="https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F732.3.126.png?alt=media&token=7c4a09b7-4781-4211-8484-c623b614ba66"
            alt="OLSLM Update 732.3.126.3399 - Sun Light Meditation Progress"
          />
          <UpdateParagraph>
            <UpdateLink
              href="https://odysee.com/@onelightsystemOLS:f/732.-olsm__12lh-126-2-40:f?r=7Lzv2RSF7jJWdCHdCm1Tnckp8TYcaK6o"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Watch 732.12.126.3399 video on Odysee"
            >
              <HighlightedText>732.12.126.3399</HighlightedText>
            </UpdateLink>
          </UpdateParagraph>
          <UpdateImage
            src="https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F732.12.126.png?alt=media&token=162a5cfd-c833-42e1-b077-4784fbd9fdcc"
            alt="OLSLM Update 732.12.126.3399 - Sun Light Meditation Progress"
          />
          <UpdateParagraph>
            <UpdateLink
              href="https://odysee.com/@onelightsystemOLS:f/1463.olslm-1lh.-%28active-meditation%29:c?r=7Lzv2RSF7jJWdCHdCm1Tnckp8TYcaK6o"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Watch 1463.1.126.3401 video on Odysee"
            >
              <HighlightedText>1463.1.126.3401</HighlightedText>
            </UpdateLink>
          </UpdateParagraph>
          <UpdateImage
            src="https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F1463.1.126.png?alt=media&token=bbeb6f07-fd06-4ec7-8e65-c03ce3d9a675"
            alt="OLSLM Update 1463.1.126.3401 - Active Meditation Session"
          />
          <UpdateParagraph>
            <UpdateLink
              href="https://odysee.com/@onelightsystemOLS:f/1828.OLSLM-1Lh-%28active-meditation%29-126.4.26.718a---720WebShareName:0?r=7Lzv2RSF7jJWdCHdCm1Tnckp8TYcaK6o"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Watch 1828.1.126.3402 video on Odysee"
            >
              <HighlightedText>1828.1.126.3402</HighlightedText>
            </UpdateLink>
          </UpdateParagraph>
          <UpdateImage
            src="https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F1828.1.126.png?alt=media&token=46c89382-c11a-46da-b63c-35d829c87c72"
            alt="OLSLM Update 1828.1.126.3402 - Active Meditation Session"
          />
          <UpdateParagraph>
            <UpdateLink
              href="https://odysee.com/@onelightsystemOLS:f/2193.OLSLM--1Lh--M41-126---HD-1080p:5?r=7Lzv2RSF7jJWdCHdCm1Tnckp8TYcaK6o"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Watch 2193.1.126.3402 video on Odysee"
            >
              <HighlightedText>2193.1.126.3402</HighlightedText>
            </UpdateLink>
          </UpdateParagraph>
          <UpdateImage
            src="https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F2193.1.126.png?alt=media&token=31b29be4-44d7-46f8-bcb4-42a538704376"
            alt="OLSLM Update 2193.1.126.3402 - Advanced Meditation Session"
          />
          <UpdateParagraph>
            Join our luminous community and dive into these enhanced sessions! Visit{" "}
            <UpdateLink
              href="/OLSStudentProspect"
              aria-label="Join OLS as a student"
            >
              OLS Student Prospect
            </UpdateLink>{" "}
            to begin your Sun Light Meditation journey today.
          </UpdateParagraph>

          <ShareThisWrapper>
            <InlineShareButtons
              config={{
                alignment: "center",
                color: "social",
                enabled: true,
                font_size: 12,
                labels: "cta",
                language: "en",
                networks: [
                  "whatsapp",
                  "linkedin",
                  "messenger",
                  "facebook",
                  "twitter",
                  "blogger",
                  "pinterest",
                  "sms",
                ],
                padding: 9,
                radius: 4,
                show_total: true,
                min_count: 10,
                url: "https://www.olsme.com/olsupdates/ols2900/2924.olslm",
                image:
                  "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F732.3.126.png?alt=media&token=7c4a09b7-4781-4211-8484-c623b614ba66",
                description:
                  "Explore the latest OLSLM update for onelightsystem OLS, featuring enhanced Sun Light Meditation sessions and resources for our radiant community.",
                title: "OLSLM: 2924.126.3413 - onelightsystem OLS",
                message:
                  "Check out this latest OLSLM update from onelightsystem OLS!",
                subject: "OLSLM Update: 2924.126.3413",
                username: "onelightsystem",
              }}
            />
          </ShareThisWrapper>
        </UpdateContent>
      </UpdateContainer>

      <Footer />
    </Layout>
  );
};

export default OLSLM2924;